export default __webpack_public_path__ + "static/media/misc-pantry1-1024w.01095a2f.avif";